import { FieldFormat, PropertyConfig, SectionConfig } from "../../types";
import { selectApprovalSteps } from "../selectors";

const EXPIRATION_UNIT: FieldFormat = {
  enum: {
    MINUTES: "approvalSteps.reminderUnit.MINUTES",
    HOURS: "approvalSteps.reminderUnit.HOURS",
    DAYS: "approvalSteps.reminderUnit.DAYS",
  },
};

// Shared by the Temporary Hold and Approval Steps sections, which show the
// same two notifications. Each reuses the labels its own form step displays,
// so the two prefixes cannot share a single helper.
const SENDER_NOTIFICATION: Record<string, PropertyConfig> = {
  senderTitle: { label: "approvalSteps.senderTitle" },
  senderBodyText: { label: "approvalSteps.senderBodyText" },
  senderAccessLink: {
    label: "approvalSteps.senderAccessLink",
    format: "boolean",
  },
  senderAccessLinkLabel: { label: "approvalSteps.senderAccessLinkLabel" },
  senderCancelLink: {
    label: "approvalSteps.senderCancelLink",
    format: "boolean",
  },
  senderCancelLinkLabel: { label: "approvalSteps.senderCancelLinkLabel" },
};

/** Names the reminder recipient the way the form's own labels do. */
const REMINDER = { recipient: "approvalSteps.recipientType.reminder" };

const REMINDER_NOTIFICATION: Record<string, PropertyConfig> = {
  reminderSenderTitle: { label: "sendDelay.reminderTitle" },
  reminderSenderBodyText: { label: "sendDelay.reminderBody" },
  reminderSenderAccessLink: {
    label: "approvalSteps.accessLink",
    labelParams: REMINDER,
    format: "boolean",
  },
  reminderSenderAccessLinkLabel: {
    label: "sendDelay.senderNotification.accessLinkLabel",
  },
  reminderSenderCancelLink: {
    label: "approvalSteps.cancelLink",
    labelParams: REMINDER,
    format: "boolean",
  },
  reminderSenderCancelLinkLabel: {
    label: "sendDelay.senderNotification.cancelLinkLabel",
  },
};

const config: SectionConfig = {
  section: "approvalSteps",
  titleKey: "confirmRuleUpdates.approvalStepsChanges.title",
  selector: selectApprovalSteps,
  properties: {
    supervisors: {
      label: "confirmRuleUpdates.approvalStepsChanges.supervisors",
      format: { resolve: "supervisor" },
      getItemKey: item =>
        (item as { entity?: string }).entity ?? JSON.stringify(item),
    },
    expirationValue: {
      label: "approvalSteps.expiration.value",
      format: "number",
    },
    expirationType: {
      label: "approvalSteps.expiration.type",
      format: EXPIRATION_UNIT,
    },
    reminderValue: {
      label: "approvalSteps.reminderInterval.value",
      format: "number",
    },
    reminderType: {
      label: "approvalSteps.reminderInterval.type",
      format: EXPIRATION_UNIT,
    },
    ...SENDER_NOTIFICATION,
    ...REMINDER_NOTIFICATION,
    supervisorTitle: { label: "approvalSteps.supervisorTitle" },
    supervisorSubject: { label: "approvalSteps.supervisorSubject" },
    supervisorBodyText: { label: "approvalSteps.supervisorBodyText" },
    supervisorAccessLink: {
      label: "approvalSteps.supervisorAccessLink",
      format: "boolean",
    },
    supervisorAccessLinkLabel: {
      label: "approvalSteps.supervisorAccessLinkLabel",
    },
    supervisorApproveLink: {
      label: "approvalSteps.supervisorApproveLink",
      format: "boolean",
    },
    supervisorApproveLinkLabel: {
      label: "approvalSteps.supervisorApproveLinkLabel",
    },
    supervisorRejectLink: {
      label: "approvalSteps.supervisorRejectLink",
      format: "boolean",
    },
    supervisorRejectLinkLabel: {
      label: "approvalSteps.supervisorRejectLinkLabel",
    },
    doneTitle: { label: "approvalSteps.doneTitle" },
    doneApprovedBodyText: { label: "approvalSteps.doneApprovedBodyText" },
    doneRejectedBodyText: { label: "approvalSteps.doneRejectedBodyText" },
  },
};

export default config;
